/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function TrashFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="trash-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M5.5 4.75C5.914 4.75 6.25 5.086 6.25 5.5L17.75 5.5C17.75 5.086 18.086 4.75 18.5 4.75C18.914 4.75 19.25 5.086 19.25 5.5L19.25 19.5C19.217 20.206 18.901 20.988 18.445 21.445C17.988 21.901 17.206 22.217 16.5 22.25L7.5 22.25C6.794 22.217 6.012 21.901 5.555 21.445C5.099 20.988 4.783 20.206 4.75 19.5L4.75 5.5C4.75 5.086 5.086 4.75 5.5 4.75ZM9.25 10.5L9.25 15C9.25 15.414 9.586 15.75 10 15.75C10.414 15.75 10.75 15.414 10.75 15L10.75 10.5C10.75 10.086 10.414 9.75 10 9.75C9.586 9.75 9.25 10.086 9.25 10.5ZM13.25 10.5L13.25 15C13.25 15.414 13.586 15.75 14 15.75C14.414 15.75 14.75 15.414 14.75 15L14.75 10.5C14.75 10.086 14.414 9.75 14 9.75C13.586 9.75 13.25 10.086 13.25 10.5Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M4 5.5L20 5.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10 5.5L10 4.5C10 3.395 10.895 2.5 12 2.5C13.105 2.5 14 3.395 14 4.5L14 5.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
